<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-panel
    *ngIf="vm.customerDetails as customerDetails"
    [border]="border"
    [rounded]="rounded"
    [variant]="variant"
  >
    <h2 class="mb-4 typog-h3 checkout-customer-details__title">
      {{ 'CHECKOUT_CUSTOMER_DETAILS_TITLE' | translate }}
    </h2>
    <dgx-components-description-list [spacing]="'sm'">
      <dgx-components-description-list-item
        [data]="customerDetails.title"
        [stacked]="true"
        [title]="'CHECKOUT_CUSTOMER_TITLE' | translate"
        [variant]="'bordered'"
      />
      <dgx-components-description-list-item
        [data]="customerDetails.firstName + ' ' + customerDetails.surname"
        [dgxQmSanitise]="'block'"
        [stacked]="true"
        [title]="'CHECKOUT_CUSTOMER_NAME' | translate"
        [variant]="'bordered'"
      />
      <dgx-components-description-list-item
        *ngIf="customerDetails.email"
        [data]="customerDetails.email.main"
        [dgxQmSanitise]="'block'"
        [stacked]="true"
        [title]="'CHECKOUT_CUSTOMER_EMAIL' | translate"
        [variant]="'bordered'"
      />
      <dgx-components-description-list-item
        *ngIf="customerDetails.telephoneDetails"
        [data]="customerDetails.telephoneDetails.mobile"
        [dgxQmSanitise]="'block'"
        [stacked]="true"
        [title]="'CHECKOUT_CUSTOMER_PHONE' | translate"
        [variant]="'bordered'"
      />
      <dgx-components-description-list-item
        [data]="
          customerDetails?.address | dgxAddressToArray | conjunction : ','
        "
        [dgxQmSanitise]="'block'"
        [stacked]="true"
        [title]="'CHECKOUT_CUSTOMER_ADDRESS' | translate"
        [variant]="'bordered'"
      />
    </dgx-components-description-list>
  </dgx-components-panel>
</ng-container>
